export const MySubscription_Status = {
    BOOKED: "Booked", 
    OPEN: "Open", 
    COMPLETED: "Completed", 
    CANCELED: "Canceled", 
    PENDING: "Pending"
}